import { AjaxLoader } from './ajaxLoader';
import { Logger } from './logger';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';
import { getPartnerHost } from '@/util/partner-host';

export const FetchPartnerData = {
  mixins: [AjaxLoader, Logger],
  methods: {
    async fetchPartnerData(options = {}) {
      const userStore = useUserStore();
      const router = useRouter();

      if (this.$auth.isAuthenticated() && !userStore.performSignup) {
        this.logInfo('going to dashboard from login');
        // Pass all options as query parameters to dashboard redirect
        // Ensure options is an object before spreading
        const safeOptions = options && typeof options === 'object' && !Array.isArray(options) ? options : {};

        // fetch query from useRouter
        const queryParams = { ...router.currentRoute.value.query, ...safeOptions };

        return this.$router.push({ name: 'dashboard', query: queryParams });
      }

      this.$conn.env = window.location.host;

      this.logInfo('get partner info');

      const [subdomain, domain] = getPartnerHost().split('.');

      await this.$conn
        .loadPartnerDetails(subdomain, domain)
        .then((res) => {
          if ((res.data || {}).errorMessage) {
            this.logError('get partner info failed', res.data.errorMessage);

            return this.$router.push({
              name: 'server-error',
              query: { referenceId: userStore.welcomePageData.referenceId }
            });
          }

          userStore.setPartnerData((this.$conn.partnerData || {}).welcomePageData);

          this.logInfo('get partner info success', res.data);
        })
        .catch((err) => {
          this.logError('get partner info failed', err);
        });
    }
  }
};
